var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 137,
    viewBox: "0 0 180 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -20,
    y: -20,
    width: 177,
    height: 177
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_0_3_55_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 20,
    cx: 68.5,
    cy: 68.5,
    r: 67.5,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5262 97.8235C79.1442 97.6522 90.9411 85.6605 90.9411 71.0134C90.9411 62.7049 87.1798 55.2528 81.1958 50.3705C80.4264 49.7709 79.5716 49.4283 78.6313 49.4283H49.7373C48.797 49.4283 47.8566 49.7709 47.1728 50.3705C41.1033 55.4242 37.2565 63.1331 37.4275 71.6987C37.7694 86.2601 49.9938 98.0805 64.5262 97.8235Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0666 53.1971H52.3873C51.3614 53.1971 50.3356 53.5397 49.4808 54.225C44.3517 58.5934 41.2742 65.1889 41.6162 72.5552C42.1291 83.9474 51.1905 93.2838 62.56 94.0547C75.8102 94.9969 86.7523 84.4613 86.7523 71.4417C86.7523 64.5893 83.6748 58.3364 78.8022 54.225C78.1183 53.5397 77.0925 53.1971 76.0666 53.1971Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1843 76.9236C67.2059 76.9236 69.6553 74.4693 69.6553 71.4417C69.6553 68.4141 67.2059 65.9597 64.1843 65.9597C61.1627 65.9597 58.7133 68.4141 58.7133 71.4417C58.7133 74.4693 61.1627 76.9236 64.1843 76.9236Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1843 74.1827C65.695 74.1827 66.9198 72.9555 66.9198 71.4417C66.9198 69.9279 65.695 68.7007 64.1843 68.7007C62.6735 68.7007 61.4487 69.9279 61.4487 71.4417C61.4487 72.9555 62.6735 74.1827 64.1843 74.1827Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.773 65.1032C59.567 65.1032 61.0214 63.6459 61.0214 61.8483C61.0214 60.0507 59.567 58.5934 57.773 58.5934C55.9789 58.5934 54.5245 60.0507 54.5245 61.8483C54.5245 63.6459 55.9789 65.1032 57.773 65.1032Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.773 63.4758C58.67 63.4758 59.3972 62.7471 59.3972 61.8483C59.3972 60.9495 58.67 60.2209 57.773 60.2209C56.876 60.2209 56.1488 60.9495 56.1488 61.8483C56.1488 62.7471 56.876 63.4758 57.773 63.4758Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5957 65.1032C72.3898 65.1032 73.8442 63.6459 73.8442 61.8483C73.8442 60.0507 72.3898 58.5934 70.5957 58.5934C68.8017 58.5934 67.3473 60.0507 67.3473 61.8483C67.3473 63.6459 68.8017 65.1032 70.5957 65.1032Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5958 63.4758C71.4928 63.4758 72.22 62.7471 72.22 61.8483C72.22 60.9495 71.4928 60.2209 70.5958 60.2209C69.6987 60.2209 68.9716 60.9495 68.9716 61.8483C68.9716 62.7471 69.6987 63.4758 70.5958 63.4758Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0071 76.9236C80.0286 76.9236 82.4781 74.4693 82.4781 71.4417C82.4781 68.4141 80.0286 65.9597 77.0071 65.9597C73.9855 65.9597 71.536 68.4141 71.536 71.4417C71.536 74.4693 73.9855 76.9236 77.0071 76.9236Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0071 74.1827C78.5179 74.1827 79.7426 72.9555 79.7426 71.4417C79.7426 69.9279 78.5179 68.7007 77.0071 68.7007C75.4963 68.7007 74.2716 69.9279 74.2716 71.4417C74.2716 72.9555 75.4963 74.1827 77.0071 74.1827Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7729 88.6584C60.7945 88.6584 63.244 86.2041 63.244 83.1765C63.244 80.1489 60.7945 77.6945 57.7729 77.6945C54.7513 77.6945 52.3019 80.1489 52.3019 83.1765C52.3019 86.2041 54.7513 88.6584 57.7729 88.6584Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.773 85.9175C59.2838 85.9175 60.5085 84.6903 60.5085 83.1765C60.5085 81.6627 59.2838 80.4355 57.773 80.4355C56.2622 80.4355 55.0375 81.6627 55.0375 83.1765C55.0375 84.6903 56.2622 85.9175 57.773 85.9175Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5957 88.6584C73.6172 88.6584 76.0667 86.2041 76.0667 83.1765C76.0667 80.1489 73.6172 77.6945 70.5957 77.6945C67.5741 77.6945 65.1246 80.1489 65.1246 83.1765C65.1246 86.2041 67.5741 88.6584 70.5957 88.6584Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5958 85.9175C72.1065 85.9175 73.3313 84.6903 73.3313 83.1765C73.3313 81.6627 72.1065 80.4355 70.5958 80.4355C69.085 80.4355 67.8602 81.6627 67.8602 83.1765C67.8602 84.6903 69.085 85.9175 70.5958 85.9175Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3615 76.9236C54.3831 76.9236 56.8326 74.4693 56.8326 71.4417C56.8326 68.4141 54.3831 65.9597 51.3615 65.9597C48.34 65.9597 45.8905 68.4141 45.8905 71.4417C45.8905 74.4693 48.34 76.9236 51.3615 76.9236Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3616 74.1827C52.8724 74.1827 54.0971 72.9555 54.0971 71.4417C54.0971 69.9279 52.8724 68.7007 51.3616 68.7007C49.8508 68.7007 48.6261 69.9279 48.6261 71.4417C48.6261 72.9555 49.8508 74.1827 51.3616 74.1827Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.876 118.466L170.1 131.4L179.162 124.891L170.271 109.473",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.876 118.466L170.1 131.4L179.162 124.891L170.271 109.473",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1281 89.3437H66.7488C65.894 89.3437 65.1246 88.6584 65.1246 87.7162V60.3065C65.1246 59.45 65.8085 58.6791 66.7488 58.6791H85.1281V89.3437Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.046 92.2559L114.364 86.9453C115.732 86.1744 117.185 85.6605 118.638 85.4892C121.887 85.1466 127.443 84.9752 130.777 88.0588C134.709 91.6564 147.874 110.415 152.918 117.61C154.029 119.152 156.166 119.58 157.79 118.466L170.271 109.473C171.81 108.359 172.152 106.303 171.126 104.762C154.542 79.7503 137.616 66.388 128.298 61.5057C118.724 56.3664 105.046 56.8803 105.046 56.8803",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.046 92.2559L114.364 86.9453C115.732 86.1744 117.185 85.6605 118.638 85.4892C121.887 85.1466 127.443 84.9752 130.777 88.0588C134.709 91.6564 147.874 110.415 152.918 117.61C154.029 119.152 156.166 119.58 157.79 118.466L170.271 109.473C171.81 108.359 172.152 106.303 171.126 104.762C154.542 79.7503 137.616 66.388 128.298 61.5057C118.724 56.3664 105.046 56.8803 105.046 56.8803",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.707 74.5253H70.5957C69.3134 74.5253 68.2876 73.4974 68.2876 72.2126C68.2876 70.9278 69.3134 69.8999 70.5957 69.8999H71.707C72.9893 69.8999 74.0151 70.9278 74.0151 72.2126C74.0151 73.4974 72.9893 74.5253 71.707 74.5253Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1246 64.161H85.1281",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.132 56.8803H85.1281V92.256H105.132V56.8803Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6846 63.2188C91.7233 63.2188 92.5653 62.3751 92.5653 61.3344C92.5653 60.2936 91.7233 59.45 90.6846 59.45C89.646 59.45 88.804 60.2936 88.804 61.3344C88.804 62.3751 89.646 63.2188 90.6846 63.2188Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.026 74.097C135.064 74.097 135.906 73.2533 135.906 72.2126C135.906 71.1719 135.064 70.3282 134.026 70.3282C132.987 70.3282 132.145 71.1719 132.145 72.2126C132.145 73.2533 132.987 74.097 134.026 74.097Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6846 89.3437C91.7233 89.3437 92.5653 88.5 92.5653 87.4592C92.5653 86.4185 91.7233 85.5748 90.6846 85.5748C89.646 85.5748 88.804 86.4185 88.804 87.4592C88.804 88.5 89.646 89.3437 90.6846 89.3437Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1281 61.3344H88.8039",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5653 61.3344H105.046",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3_55_clip_path",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 68.5,
    r: 67.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142.76,
    height: 83,
    fill: "white",
    transform: "translate(37 49)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlug);
export default __webpack_public_path__ + "static/media/img_plug.ae59e83ec37bf1245039f156d86e51cc.svg";
export { ForwardRef as ReactComponent };